<script>
import updateDeviceToken from '../../assets/site/js/lib/update-device-token';

export default {
  methods: {
    /**
         * Redirect user to given provider endpoint
         */
    redirectTo(provider, rememberMe) {
      // Device token is used for login only, if user already has an account
      const deviceToken = updateDeviceToken.getOrUpdateToken();

      let url = `/api/sign-in/${provider}?device_token=${deviceToken}&url=${window.location.href}`;

      if (rememberMe === true) {
        url += '&remember_me=true';
      }

      window.location.href = url;
    },
  },
};
</script>
